    <!-- =========================================================================================
    File Name: SettingsChangePassword.vue
    Description: Change Password in Settings page
========================================================================================== -->
<template>
  <vx-card no-shadow>
    <div class="mb-base">
      <feather-icon icon="LockIcon" class="p-3 inline-flex rounded-full text-success" :style="{background: `rgba(var(--vs-success),.15)`}"></feather-icon>
      <span class="text-3xl text-success mb-base ml-4">{{$t('ChangePassword')}}</span>
    </div>

    <vs-input class="w-full" :label-placeholder="$t('CURRENT_PASSWORD')" name="currentPassword" ref="currentPassword " v-model="currentPassword" type="password" 
    v-validate="{  required: true, min:8, max:20, regex:/(?=.{8,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/}"  maxlength="21" icon-pack="feather" icon="icon-lock" icon-no-border/>
    <span class="text-danger text-sm  mb-base" v-show="errors.has('currentPassword')">{{ errors.first('currentPassword') }}</span>

    <vs-input class="w-full mt-8" :label-placeholder="$t('NEW_PASSWORD')" name="newPassword" ref="newPassword" v-model="newPassword" type="password" 
    v-validate="{  required: true, min:8, max:20, regex:/(?=.{8,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/}" maxlength="21"  icon-pack="feather" icon="icon-lock" icon-no-border/>
    <span class="text-danger text-sm  mb-base" v-show="errors.has('newPassword')">{{ errors.first('newPassword') }}</span>
    
    <vs-input class="w-full mt-8" :label-placeholder="$t('CONFIRM_NEW_PASSWORD')" name="confirmNewPassword" ref="confirmNewPassword" v-model="confirmNewPassword" type="password" 
    v-validate="{  required: true, min:8, max:20, confirmed:'newPassword' }" maxlength="21" icon-pack="feather" icon="icon-lock" icon-no-border/>
    <span class="text-danger text-sm  mb-base" v-show="errors.has('confirmNewPassword')">{{ errors.first('confirmNewPassword') }}</span>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end mt-8">
      <vs-button class="ml-4 mt-2" @click="checkValid" :disabled="!isFormValid">{{$t('SUBMIT')}}</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning" @click="resetPasswords">{{this.$t('RESET')}}</vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    isFormValid() {
        return !this.errors.any()
    },
  },
  methods: {        
    checkValid(){
      this.$validator.validateAll().then(result => {
          if(result){
              if(this.currentPassword === this.newPassword){
                  this.errorAlert(this.$t("ERROR"), this.$t("PASSWORD_SAME_MESSAGE"))
              }else{
                  this.changePassword()
              }
          }
      })
      .catch((error)=>{
          console.log(error)
          this.errorAlert(this.$t("ERROR"), error.message)
      })
    },
    changePassword(){
      this.$vs.loading()

      const obj = {
        adminId : this.activeUserInfo.userId,
        currentPassword: this.currentPassword,
        newPassword: this.newPassword
      }

      this.$store.dispatch("dataAdmin/changeAdminPassword", obj)
      .then(() => {

        this.$vs.loading.close()
        this.successAlert(this.$t("SUCCESS"),this.$t("CHANGE_PASSWORD_SUCCESS"))
        setTimeout(()=>{
            window.sessionStorage.clear();
                this.$router.push('/pages/login')
        },2000)
          
      })
      .catch(error => { 
        if (error.message === "CURRENT_PASSWORD_IS_NOT_MATCH"){
            this.errorAlert(this.$t("ERROR"), this.$t(error.message))
        } else {
            this.errorAlert(this.$t("ERROR"), error.message)
        }
        
        this.$vs.loading.close()
      })
    },
    resetPasswords(){
      this.currentPassword = ''
      this.newPassword = ''
      this.confirmNewPassword = ''
    }
  },
}
</script>
